import { createFileRoute } from '@tanstack/react-router'
import { CreditNoteDetailPage } from '../../../../features/sales/credit-note-pages'
import { documentActionSearchSchema } from '../../../../features/sales/document-action'

export const Route = createFileRoute('/_app/credit-notes/$creditNoteId/')({
  validateSearch: documentActionSearchSchema,
  component: CreditNoteDetailPage,
})
